// extracted by mini-css-extract-plugin
export default {"placeholderClass":"_c80ea34d"};